// extracted by mini-css-extract-plugin
export var positionAbsolute = "CardTags-module--position-absolute--f971c";
export var tags = "CardTags-module--tags--1dede";